<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="ui-module-card ui-module-fade-in-up personal-equipamiento-shell" flat>
          <v-card-text class="pa-0">
            <v-container fluid>
              <v-row justify="end" align="center" class="px-4 pt-4">
                <v-col cols="12" md="4">
                  <BaseInput label="Filtrar elementos" v-model="buscaPersonal" class="ui-form-field"></BaseInput>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-data-table
                    class="transparent ui-module-table"
                    :headers="headers"
                    :items="filteredPersonal"
                    :loading="loading"
                    calculate-widths
                    :items-per-page="15"
                    :footer-props="{
                      'items-per-page-options': [10, 15, 25, 50, 100],
                    }"
                  >
                    <template v-slot:[`item.nombre`]="{ item }">
                      <div class="d-inline-flex align-center py-2">
                        <v-avatar size="40" class="mr-3">
                          <v-img :src="item.foto"></v-img>
                        </v-avatar>
                        <span class="text-body-2">{{ getFullName(item) }}</span>
                      </div>
                    </template>
                    <template v-slot:[`item.vigenciaEvaluacionC3`]="{ item }">
                      <span
                        :class="
                          item.vigenciaEvaluacionC3 && !item.vigenciaEvaluacionC3.startsWith('1900-01-01')
                            ? 'success--text font-weight-bold'
                            : 'error--text font-weight-bold'
                        "
                      >
                        {{ formatearFecha(item.vigenciaEvaluacionC3) }}
                      </span>
                    </template>
                    <template v-slot:[`item.opciones`]="{ item }">
                      <span class="d-flex align-center">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" class="mx-1">
                              <IconButton
                                class="ui-module-icon-action"
                                variant="secondary"
                                icon="mdi-briefcase-plus"
                                @click="openAsignacionDialog(item)"
                              />
                            </span>
                          </template>
                          <span>Asignar equipamiento</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" class="mx-1">
                              <IconButton
                                class="ui-module-icon-action"
                                variant="secondary"
                                icon="mdi-list-box-outline"
                                :to="{ name: 'historicoRegistroEquipamiento', params: { id: item.idPersonal } }"
                              />
                            </span>
                          </template>
                          <span>Histórico de asignación de equipamiento</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" class="mx-1">
                              <IconButton
                                class="ui-module-icon-action"
                                variant="secondary"
                                icon="mdi-file-word"
                                @click="generarConstanciaNoAdeudoAntimotin(item)"
                              />
                            </span>
                          </template>
                          <span>Constancia de No Adeudo Antimotin</span>
                        </v-tooltip>
                      </span>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Packer } from 'docx'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import IconButton from '@/components/base/IconButton.vue'
import BaseInput from '@/components/base/BaseInput.vue'
import { DIALOG_TYPES } from '@/plugins/dialog-types'
import FormatoNoAdeudoAntimotin from '@/utils/doc-generator/armeria/FormatoNoAdeudoAntimotin'

export default {
  components: {
    IconButton,
    BaseInput,
  },

  data() {
    return {
      loading: false,
      buscaPersonal: '',
      headers: [
        { text: 'Nombre', value: 'nombre', width: '300px' },
        { text: 'Puesto', value: 'puesto', sortable: false },
        { text: 'Vigencia C3', value: 'vigenciaEvaluacionC3', align: 'center', sortable: false },
        { text: 'Opciones', value: 'opciones', align: 'left', sortable: false },
      ],
    }
  },

  async mounted() {
    this.loading = true
    if (this.personal.length === 0) {
      await this.fetchPersonalByDependencia(1)
    }
    this.loading = false
  },

  computed: {
    ...mapGetters('personal', {
      personal: 'getFullPersonal',
    }),

    filteredPersonal() {
      const term = (this.buscaPersonal || '').trim().toLowerCase()
      if (!term) return this.personal || []
      return (this.personal || []).filter((item) => this.getFullName(item).toLowerCase().includes(term))
    },
  },

  methods: {
    ...mapActions('personal', ['fetchPersonalByDependencia']),
    ...mapMutations('dialog', ['SET_DIALOG']),

    openAsignacionDialog(item) {
      this.SET_DIALOG({
        ...DIALOG_TYPES.ASIGNAR_EQUIPAMIENTO,
        props: { idPersonal: item.idPersonal },
      })
    },

    getFullName(person) {
      if (!person) return ''
      return [person.apaterno, person.amaterno, person.nombre, person.segundoNombre].filter(Boolean).join(' ')
    },

    formatearFecha(fecha) {
      if (!fecha || fecha.startsWith('1900-01-01')) return 'No registrada'
      const [year, month, day] = fecha.split('-')
      return `${day}/${month}/${year}`
    },

    async generarConstanciaNoAdeudoAntimotin(personal) {
      const nombreCompleto = [personal.apaterno, personal.amaterno, personal.nombre, personal.segundoNombre || '']
        .join(' ')
        .replace(/\s+/g, ' ')
        .trim()

      const puesto = personal.CatPuestoDependencia?.catPuesto?.title || 'SIN PUESTO'
      const fecha = new Date().toISOString().slice(0, 10)

      const doc = new FormatoNoAdeudoAntimotin({ nombre: nombreCompleto, puesto, fecha })
      const newDoc = await doc.generate()
      const blob = await Packer.toBlob(newDoc)
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `FormatoNoAdeudoAntimotin_${nombreCompleto}.docx`
      a.click()
      window.URL.revokeObjectURL(url)
    },
  },
}
</script>

<style scoped>
::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(255, 159, 67, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  transition: all 0.3s ease !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(255, 159, 67, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label,
::v-deep .ui-form-field .mdi-magnify {
  color: rgba(255, 190, 118, 0.75) !important;
  font-weight: 500;
}

::v-deep .ui-form-field.v-input--is-focused .v-label {
  color: #ffbe76 !important;
  font-weight: 600;
}

::v-deep .v-tooltip__content {
  background: rgba(16, 16, 30, 0.96) !important;
  color: #e0e0e0 !important;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.3);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 16px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.2);
}

::v-deep .v-data-footer {
  border-top: 1px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.2) !important;
  background: transparent !important;
}

::v-deep .v-data-footer__select .v-select__selection,
::v-deep .v-data-footer__pagination {
  color: rgba(255, 255, 255, 0.9) !important;
}

::v-deep .v-data-footer .v-btn--icon {
  color: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.8) !important;
}

::v-deep .v-data-footer .v-btn--icon:hover {
  color: var(--v-secondary-base) !important;
}

::v-deep .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::v-deep .v-data-table__wrapper::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}

::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.4);
  border-radius: 4px;
}

::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.6);
}

.personal-equipamiento-shell {
  min-height: calc(100vh - 64px);
  min-height: calc(100dvh - 64px);
}

::v-deep .personal-equipamiento-shell.v-card {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
}

::v-deep .personal-equipamiento-shell.v-card:hover {
  transform: none !important;
  box-shadow: none !important;
}
</style>
